import { Skeleton, Stack } from '@mui/material';
import React from 'react';

const AvatarSkeleton: React.FC = () => {
  return (
    <Stack direction="column" alignItems="center" justifyContent="center" spacing={-14}>
      <Skeleton
        variant="text"
        width="55vw"
        height="10vh"
        data-testid="text-skeleton-1"
      />
      <Skeleton
        variant="text"
        width="55vw"
        height="100vh"
        data-testid="text-skeleton-2"
      />
      <Skeleton
        variant="rectangular"
        width="15vw"
        height="5vh"
        data-testid="rectangular-skeleton"
        sx={{
          position: 'fixed',
          left: '59.5%',
          bottom: '28px !important',
          padding: '10px 20px',
          border: 'none',
        }}
      />
    </Stack>
  );
};

export default AvatarSkeleton;